module.exports = __webpack_public_path__ + "static/collections.beacf8c7.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Nav/imgs/collections.png
// module id = 2737
// module chunks = 0